import Tables from 'src/class/Tables';
import i18n from 'src/i18n';


const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'start_date',
      label: i18n.t('common_words.date'),
      minWidth: 200,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'calibration_type.name',
      label: i18n.t('calibration.hands_type'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },

  ];

  return { Table };
};

export default configTable;